module.exports = __webpack_public_path__ + "static/media/receta-01.e556ff0a.png";